import { useEffect, useState } from "react";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Programs } from "../components/site/Programs";
import { Pricing } from "../components/site/Pricing";
import { Specialty } from "../components/site/Specialty";
import { Contact } from "../components/site/Contact";
import { FloatingCta } from "../components/site/FloatingCta";
import { ClassDialog } from "../components/site/ClassDialog";
import { Footer } from "../components/site/Footer";
import { fetchContent } from "../lib/api";
import { normalize, DEFAULT_CONTENT, applyTheme } from "../lib/content";
import { LangProvider } from "../lib/i18n";
import { useLenis } from "../hooks/useLenis";
import { AnnouncementBar, useAnnouncement } from "../components/site/AnnouncementBar";

export default function Home() {
  // Placeholder until the API responds; images left blank so stock defaults aren't downloaded twice
  const [content, setContent] = useState(() => {
    const d = normalize(DEFAULT_CONTENT);
    return { ...d, images: { hero: "", programs: "" }, classes: d.classes.map((c) => ({ ...c, image: "" })) };
  });
  const [active, setActive] = useState(null);
  const [bannerH, setBannerH] = useState(0);
  const { show: showBanner, dismiss } = useAnnouncement(content.announcement);
  useLenis();
  useEffect(() => {
    let alive = true;
    fetchContent().then((c) => { if (alive) setContent(c); });
    return () => { alive = false; };
  }, []);
  useEffect(() => { applyTheme(content.theme); }, [content.theme]);

  const SECTIONS = {
    marquee: <div className="mt-20 lg:mt-24"><Marquee /></div>,
    programs: <Programs classes={content.classes} onOpen={setActive} image={content.images.programs} />,
    rates: <Pricing pricing={content.pricing} classes={content.classes} />,
    specialty: <Specialty classes={content.classes} onOpen={setActive} />,
    contact: <Contact contact={content.contact} pricing={content.pricing} />,
  };

  return (
    <LangProvider texts={content.texts}>
    <div className="grain min-h-screen bg-[#0B0B0E] text-white" data-testid="home-page">
      <Nav contact={content.contact} sections={content.sections} logo={content.theme.logo}
        banner={showBanner ? <AnnouncementBar data={content.announcement} onDismiss={dismiss} onHeight={setBannerH} /> : null} />
      <div aria-hidden="true" style={{ height: showBanner ? bannerH : 0 }} />
      <main>
        <Hero content={content} onOpen={setActive} />
        {content.sections.filter((s) => s.visible).map((s) => <div key={s.id}>{SECTIONS[s.id]}</div>)}
      </main>
      <Footer contact={content.contact} logo={content.theme.logo} />
      <FloatingCta contact={content.contact} />
      <ClassDialog cls={active} onClose={() => setActive(null)} content={content} />
    </div>
    </LangProvider>
  );
}
